import * as S from 'components/HubHeader/HubHeaderStyles';
import HubSponsor, { type SponsorProps } from 'components/HubSponsor';
import SubSectionNav from 'components/SubSectionNav';
import cx from 'classnames';
import HUBPAGE_TEST_IDS from 'constants/testsIds/hubpage';
import { ARTICLE_SECTION_TEST_IDS } from 'constants/testsIds/articleComponents';
import type { MenuItemProps } from 'interfaces/navigation/Header';

export interface HubTitleProps {
  title: string;
  subMenu?: MenuItemProps[];
  pageInfo?: string;
  pageType?: string;
  sponsor?: SponsorProps;
}

const HubHeader = ({ title, subMenu, sponsor, pageInfo = '', pageType }: HubTitleProps) => {
  const hasSponsor = sponsor && sponsor.sponsorEnabled;
  return (
    <>
      <S.TitleContent className={cx({ 'has-sponsor': hasSponsor, 'the-latest': pageType === 'latest' })}>
        <S.Title
          as='h1'
          className='hub-title'
          data-cy={HUBPAGE_TEST_IDS.HUBPAGE_TITLE}
          $fontFamily='saol'
          $size={{ default: 'level2', lgMin: 'large', mdMin: 'level1' }}
        >
          {title}
        </S.Title>
        {hasSponsor && (
          <HubSponsor
            className='hub-sponsor'
            {...sponsor}
          />
        )}
      </S.TitleContent>
      {subMenu && <SubSectionNav subMenu={subMenu} />}
      {pageInfo && (
        <S.PageInfo
          as='h4'
          $size={{ default: 'level6' }}
          $fontFamily='graphikCond'
          className='page-info'
          data-cy={ARTICLE_SECTION_TEST_IDS.PAGE_INFO}
        >
          {pageInfo}
        </S.PageInfo>
      )}
    </>
  );
};
export default HubHeader;
